import { CommonModule, DatePipe, registerLocaleData } from '@angular/common';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { LOCALE_ID, NgModule } from '@angular/core';
import localePt from '@angular/common/locales/pt';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { ChartsModule } from 'ng2-charts';
import { OsModule } from '../rmpv-detalhado-os/os.module';
import { ComumModule } from '../../../shared/comum.module';
import { translateLoaderNBS } from '../../../shared/translate-loader/translateLoader';
import { DropdownModule } from 'primeng/dropdown';
import { TableModule } from 'primeng/table';
import { DialogModule } from 'primeng/dialog';
import { RmpvDetalhadoListaComponent } from './rmpv-detalhado-lista/rmpv-detalhado-lista.component';
import { RmpvDetalhadoService } from './rmpv-detalhado.service';
import { RmpvDetalhadoFiltroService } from './rmpv-detalhado-filtro.service';
import { PaginatorModule } from 'primeng/paginator';
import { ButtonModule } from 'primeng/button';
import { ToastModule } from 'primeng/toast';
import { TooltipModule } from 'primeng/tooltip';
import { InputTextModule } from 'primeng/inputtext';
import { CalendarModule } from 'primeng/calendar';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { DynamicDialogModule } from 'primeng/dynamicdialog';
import { MultiSelectModule } from 'primeng/multiselect';

registerLocaleData(localePt, 'pt');

export function translateHttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}

@NgModule({
  imports: [
    HttpClientModule,
    FormsModule,
    CommonModule,
    BrowserModule,
    ReactiveFormsModule,
    ComumModule,
    ChartsModule,
    OsModule,
    NgbModule,
    DropdownModule,
    TranslateModule.forRoot(translateLoaderNBS),
    TableModule,
    DialogModule,
    PaginatorModule,
    ButtonModule,
    ToastModule,
    TooltipModule,
    InputTextModule,
    CalendarModule,
    ProgressSpinnerModule,
    DynamicDialogModule,
    MultiSelectModule,
  ],
  exports: [
    RmpvDetalhadoListaComponent
  ],
  declarations: [
    RmpvDetalhadoListaComponent,
  ],
  providers: [
    RmpvDetalhadoService,
    RmpvDetalhadoFiltroService,
    DatePipe,
    {
      provide: LOCALE_ID,
      useValue: 'pt'
    }
  ]
})
export class RmpvDetalhadoModule { }
